import React from 'react';
import Metas from 'components/Metas';
import ProductContainer from 'containers/ProductContainer';
import style from './style.scss';//NOSONAR

const Product = (props) => {
    return (
        <div className="product-page">
            <Metas>
                <title>Product</title>
            </Metas>
            <ProductContainer {...props}/>
        </div>
    )
}

export default Product;
